import { useNavigate } from "react-router-dom";
import { allVenues } from "../../../mocks/allVenues";

interface SimilarVenuesProps {
  relatedVenueIds: string[];
  currentVenueId: string;
}

export default function SimilarVenues({ relatedVenueIds, currentVenueId }: SimilarVenuesProps) {
  const navigate = useNavigate();

  const relatedVenues = relatedVenueIds
    .filter((id) => id !== currentVenueId)
    .map((id) => allVenues.find((v) => v.id === id))
    .filter(Boolean)
    .slice(0, 4);

  if (relatedVenues.length === 0) return null;

  return (
    <section>
      <h2 className="text-xl font-bold text-stone-800 mb-5">Yakındaki Benzer Yerler</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {relatedVenues.map((venue) => {
          if (!venue) return null;
          return (
            <article
              key={venue.id}
              onClick={() => navigate(`/venue/${venue.id}`)}
              className="bg-white rounded-2xl overflow-hidden cursor-pointer group border border-stone-100 hover:border-stone-200 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Image */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src={venue.image}
                  alt={venue.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {venue.isEditorPick && (
                  <span className="absolute top-2 left-2 bg-amber-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                    Editör Seçimi
                  </span>
                )}
                {venue.isSponsored && (
                  <span className="absolute top-2 right-2 bg-stone-700/80 text-white text-xs px-2 py-0.5 rounded-full">
                    Sponsorlu
                  </span>
                )}
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h3 className="font-semibold text-stone-800 text-sm leading-tight line-clamp-2">{venue.name}</h3>
                </div>

                <div className="flex items-center gap-1 mb-2">
                  <i className="ri-star-fill text-amber-500 text-xs" />
                  <span className="text-xs font-semibold text-stone-700">{venue.rating}</span>
                  <span className="text-xs text-stone-400">({venue.reviews.toLocaleString()})</span>
                </div>

                <div className="flex items-center gap-1 text-xs text-stone-500">
                  <i className="ri-map-pin-line text-stone-400" />
                  <span className="truncate">{venue.district}</span>
                  <span className="mx-1">·</span>
                  <span className={`font-medium ${venue.isOpen ? "text-emerald-600" : "text-red-400"}`}>
                    {venue.isOpen ? "Açık" : "Kapalı"}
                  </span>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
